<template>
	<div class="lf-honor">
		<div class="lfBacView">
			<div class="patentTlite" v-show="allPatent.length > 0">{{patentName}}</div>
			<div :class="{patent: allPatent.length > 0}">
				<div :class="{patentDiv: itme.patentLabel.length > 0}" v-for="itme in patentAry">
					<LHSO v-show="itme.patentLabel.length > 0" :Img="itme.patentImg" :Times="itme.patentLabel"
						:Title="itme.patentTitle"></LHSO>
				</div>
			</div>

			<div class="grandTlite" v-show="grandAry.length > 0">{{grandName}}</div>
			<div :class="{grand: grandAry.length > 0}" :style="">
				<div class="grandDiv" v-for="itme in grandAry">
					<LHST :Img="itme.honor_img" :name="itme.honor_name"></LHST>
				</div>
			</div>


			<div class="prizeTlite" v-show="prizeAry.length > 0">{{prizeName}}</div>
			<div :class="{prize: prizeAry.length > 0}">
				<div class="prizeDiv" v-for="itme in prizeAry">
					<LHST :Img="itme.honor_img" :name="itme.honor_name"></LHST>
				</div>
				<!-- 				<div id="" style="wdith: 317.5px;height: 10px;background-color: #00C785;" v-for="itme in 3">
					
				</div> -->
			</div>
			<div class="mechanismTlite" v-show="mechanismAry.length > 0">{{mechanismName}}</div>
			<div :class="{mechanism: mechanismAry.length > 0}">
				<div class="mechanismDiv" v-for="itme in mechanismAry">
					<LHST :Img="itme.honor_img" :name="itme.honor_name" :bac="'#FFFFFF'"></LHST>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import LHSO from './LfHonorStyleOne'
	import LHST from './LfHonorStyleTow'
	import request from '../common/request.js'

	export default {
		name: 'LfHonor',
		data() {
			return {
				patentName: "核心技术专利",
				grandName: "国际大奖",
				prizeName: "国家认证及奖项",
				mechanismName: "权威坚定机构",
				patentImg: '',
				// 专利
				allPatent: [],
				inventPatentArr: [],
				newPatentArr: [],
				designPatentArr: [],

				// 荣誉
				grandAry: [],
				prizeAry: [],
				mechanismAry: []



			}
		},
		created() {
			this.getPatentList()
			this.getHonorList()
		},
		methods: {
			getPatentList() {
				// 获取专利列表
				// request.uniRequest('/patent/getPatentList')
				// 	.then(res => {
				// 		this.allPatent = res.data
				// 		// console.log('---------', this.allPatent);
				// 		this.inventPatentArr = res.data.filter(item => item.patent_type == 0)
				// 		this.newPatentArr = res.data.filter(item => item.patent_type == 1)
				// 		this.designPatentArr = res.data.filter(item => item.patent_type == 2)
				// 	}).catch(e => {})


			},
			// 获取荣誉奖项列表
			async getHonorList() {
				// request.uniRequest('/honor/getHonorList')
				// 	.then(res => {
				// 		this.grandAry = res.data.filter(item => item.honor_type == 0)
				// 		this.prizeAry = res.data.filter(item => item.honor_type == 1)
				// 		this.mechanismAry = res.data.filter(item => item.honor_type == 2)
				// 		// console.log('--------grand', this.grandAry);
				// 		// console.log('-------prize', this.prizeAry);
				// 	}).catch(e => {})

				let res = await this.$Cloud.table(`lf_func_lefan_honor`).get({
					page: 0,
					pageSize: 1000
				})
				console.log('获取奖项荣誉列表', res)

				const {
					code,
					data
				} = res

				if (code == 200) {
					this.grandAry = data.filter(item => item.is_check == 2 && item.honor_type == 0)
				this.prizeAry = data.filter(item => item.is_check == 2 && item.honor_type == 1)
				this.mechanismAry = data.filter(item => item.is_check == 2 && item.honor_type == 2)
			}
		}
	},
	computed: {
			patentAry() {
				let patentAry = [{
						patentImg: this.GLOBAL.imgHost + '/images/LfHonorImg/faming.png',
						patentLabel: this.inventPatentArr,
						// [ 
						// 	{number:"CN201810294443.4",describe:"一种自动升降桌和控制系统"},{number:"CN201711449302.7",describe:"一种基于音乐节奏的按摩模式控制方法与按摩器"},{number:"CN201711165607.5",describe:"一种眼部按摩器"},{number:"CN201711077451.5",describe:"基于呼吸频率的振动按摩控制方法及应用该方法的按摩器"},
						// ],
						patentTitle: "发明专利"
					},
					{
						patentImg: this.GLOBAL.imgHost + '/images/LfHonorImg/shiyong.png',
						patentLabel: this.newPatentArr,
						//  [
						// 	{number:"CN201820244738.6",describe:"一种壁挂式按摩器"},{number:"CN201820939630.9",describe:"一种保健按摩椅"},{number:"CN201820939668.6",describe:"一种运动型魔力贴"},{number:"CN201820939797.5",describe:"一种康复护理按摩椅"},{number:"CN201820939907.8",describe:"魔力贴康复护理系统"},{number:"CN201820930055.6",describe:"一种保健护眼仪"},{number:"CN201820930424.1",describe:"一种智能健康升降桌"},{number:"CN201820930496.6",describe:"一种具有双重按摩功能的按摩眼仪"},{number:"CN201820930826.1",describe:"一种电动式升降保健桌"},{number:"CN201820470443.0",describe:"一种自动升降桌和控制系统"},{number:"CN201820466153.9",describe:"一种升降装置和升降桌"},{number:"CN201820466887.7",describe:"一种锁定装置和升降桌"},{number:"CN201820470448.3",describe:"一种升降桌控制装置"},{number:"CN201820245327.9",describe:"一种眼部按摩器"},{number:"CN201721565629.6",describe:"一种眼部按摩器"},
						//  ],
						patentTitle: "实用新型专利"
					},
					{
						patentImg: this.GLOBAL.imgHost + '/images/LfHonorImg/waiguan.png',
						patentLabel: this.designPatentArr,
						// [
						// 	{number:"CN201730631293.8",describe:"眼部按摩器（LF-205)"},{number:"CN201730668813.2",describe:"背部支撑板"},
						// ],
						patentTitle: "外观设计专利"
					}
				]
				return patentAry;
			},
			// grandAry(){
			// 	let grandAry = [{
			// 			Img:this.GLOBAL.imgHost + '/images/LfHonorImg/hongdian.png',
			// 			name:"德国红点奖",
			// 		},{
			// 			Img:this.GLOBAL.imgHost + '/images/LfHonorImg/AWARD.png',
			// 			name:"全球UPSTYLE AWARD上格奖",
			// 		},{
			// 			Img:this.GLOBAL.imgHost + '/images/LfHonorImg/CGD.png',
			// 			name:"CGD当代好设计",
			// 		},]
			// 	return grandAry;
			// },
			// prizeAry(){
			// 	let prizeAry = [{
			// 			Img:this.GLOBAL.imgHost + '/images/LfHonorImg/gaoxin.png',
			// 			name:"国家高新技术企业证书",
			// 		},{
			// 			Img:this.GLOBAL.imgHost + '/images/LfHonorImg/chengguo.png',
			// 			name:"科技成果转化项目证书",
			// 		},{
			// 			Img:this.GLOBAL.imgHost + '/images/LfHonorImg/xiaojuren.png',
			// 			name:"厦门市科技小巨人领军企业认定",
			// 		},{
			// 			Img:this.GLOBAL.imgHost + '/images/LfHonorImg/guanlitixi.png',
			// 			name:"知识产权管理体系认证",
			// 		},{
			// 			Img:this.GLOBAL.imgHost + '/images/LfHonorImg/xiaomishengtai.png',
			// 			name:"小米生态链企业",
			// 		},{
			// 			Img:this.GLOBAL.imgHost + '/images/LfHonorImg/chuangxin.png',
			// 			name:"小米有品最佳创新奖",
			// 		},{
			// 			Img:this.GLOBAL.imgHost + '/images/LfHonorImg/qingmin.png',
			// 			name:"小米有品勤勉突破奖",
			// 		},{
			// 			Img:this.GLOBAL.imgHost + '/images/LfHonorImg/zhineng.png',
			// 			name:"中国智能终端大奖",
			// 		},{
			// 			Img:this.GLOBAL.imgHost + '/images/LfHonorImg/NOVA.png',
			// 			name:"NOVA创新扶持联盟健康类创新产品冠军奖",
			// 		},]
			// 	return prizeAry;
			// },
			// mechanismAry(){
			// 	let mechanismAry = [{
			// 			Img:this.GLOBAL.imgHost + '/images/LfHonorImg/SGS.png',
			// 			name:"SGS",
			// 			bac:"#FFFFFF",
			// 		},{
			// 			Img:this.GLOBAL.imgHost + '/images/LfHonorImg/CQC.png',
			// 			name:"中认英泰检测技术有限公司检测",
			// 			bac:"#FFFFFF",
			// 		},{
			// 			Img:this.GLOBAL.imgHost + '/images/LfHonorImg/weishengwu.png',
			// 			name:"广东省微生物研究所测试鉴定",
			// 			bac:"#FFFFFF",
			// 		},]
			// 	return mechanismAry;
			// },

		},
		components: {
			LHSO,
			LHST
		}

	}
</script>

<style scoped>
	.lf-honor {
		/* padding-right: 10px; */
		max-width: 1024px;
		margin-top: 3.75rem;
		margin-bottom: 3.75rem;
	}

	.lfBacView {
		width: 100%;
		margin: 0 auto;
		display: flex;
		margin-top: 40px;
		margin-bottom: 40px;
		flex-direction: column;
		align-items: center;
	}

	.lfBacView .patentTlite {
		width: 100%;
		font-size: 1.125rem;
		text-align: left;
		font-weight: 650;
		font-family: Alibaba-PuHuiTi-M;
	}

	.lfBacView .patent {
		width: 100%;
		margin-bottom: 9rem;
	}

	.lfBacView .patent .patentDiv {
		padding-top: 2.25rem;
	}

	.lfBacView .grandTlite {
		width: 100%;
		font-size: 1.125rem;
		text-align: left;
		font-weight: 650;
		/* margin-top: 9rem; */
		font-family: Alibaba-PuHuiTi-M;
	}

	.lfBacView .grand {
		width: 100%;
		display: flex;
		flex-direction: row;
		/* justify-self: space-between; */
		justify-content: flex-start;
		flex-wrap: wrap;
		margin-bottom: 9rem;
	}

	.lfBacView .grand .grandDiv {
		margin-top: 1.225rem;
		margin-right: 20px;
		/* margin: 0 ; */
	}

	.lfBacView .prizeTlite {
		font-family: Alibaba-PuHuiTi-M;
		width: 100%;
		font-size: 1.125rem;
		text-align: left;
		font-weight: 650;
		/* margin-top: 9rem; */
	}

	.lfBacView .prize {
		width: 100%;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		flex-wrap: wrap;
		margin-bottom: 9rem;
	}

	.lfBacView .prize .prizeDiv {
		/* margin-top: 1.225rem; */
		margin-top: 1.225rem;
		margin-right: 20px;
	}

	.lfBacView .mechanismTlite {
		font-size: 1.125rem;
		text-align: left;
		font-weight: 650;
		width: 100%;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		flex-wrap: wrap;
	}

	.lfBacView .mechanism {
		width: 100%;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		flex-wrap: wrap;
		margin-bottom: 9rem;
	}

	.lfBacView .mechanism .mechanismDiv {
		/* margin-top: 1.225rem; */
		margin-top: 1.225rem;
		margin-right: 20px;
	}
</style>
